// extracted by mini-css-extract-plugin
export var bottom = "Footer-module--bottom--94520";
export var content = "Footer-module--content--c4da4";
export var copyright = "Footer-module--copyright--c121d";
export var dark = "Footer-module--dark--1ff1a";
export var footer = "Footer-module--footer--f9074";
export var images = "Footer-module--images--2371c";
export var linkColumn = "Footer-module--linkColumn--20b8b";
export var linkColumns = "Footer-module--linkColumns--e063e";
export var secondaryNav = "Footer-module--secondaryNav--7245e";
export var socialIcons = "Footer-module--socialIcons--86eb3";
export var transparent = "Footer-module--transparent--9e06c";